import { Component, ElementRef } from '@angular/core';

import * as _ from 'lodash';

import { StateService } from '@uirouter/core';
import { EditorService } from 'src/app/editor/services/editor.service';

import { ComponentsService } from '../../services/components.service';
import { PlaylistComponentService } from '../services/playlist-component.service';
import { FolderService } from 'src/app/shared/services/folder.service';

@Component({
  selector: 'component-presentation-selector',
  templateUrl: './presentation-selector.component.html',
  styleUrls: ['./presentation-selector.component.scss'],
  standalone: false,
})
export class PresentationSelectorComponent {
  public componentId: string;

  filterConfig = {
    placeholder: 'Search Presentations',
    id: 'te-playlist-search',
  };

  constructor(
    private elementRef: ElementRef,
    private componentsFactory: ComponentsService,
    public playlistComponentFactory: PlaylistComponentService,
    private editorService: EditorService,
    public folderService: FolderService,
    public stateService: StateService,
  ) {
    this.componentsFactory.registerDirective({
      type: 'rise-presentation-selector',
      element: this.elementRef.nativeElement,
      show: () => {
        this.playlistComponentFactory.load();
      },
    });
  }

  addTemplates() {
    this.playlistComponentFactory.addTemplates();

    this.componentsFactory.showPreviousPage();
  }

  createNewTemplate() {
    this.stateService.go('apps.editor.create');
  }

  onFolderClicked(folderId: string) {
    this.playlistComponentFactory.setCurrentFolder(folderId);
  }
}
